import { takeUntil } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PreferencesService } from '../../services/preferences.service';
import { PreferenceMessages } from '../../../../shared/models/component-messages/preference-messages';
import { Preference } from '../../model/preference';

@Component({
  selector: 'app-modal-partage',
  templateUrl: './modal-partage.component.html',
  styleUrls: ['./modal-partage.component.scss']
})
export class ModalPartageComponent implements OnInit, OnDestroy {
  @Input() mode: number;
  @Input() id: number;

  @Output() preferenceCopied: EventEmitter<Preference> = new EventEmitter();

  code: string;

  wrongCode: boolean = false;

  private unsubscribe$ = new Subject<void>();

  public preferenceMessages = new PreferenceMessages();

  public form: FormGroup;

  constructor(private preferenceService: PreferencesService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.form = new FormGroup({});

    if (this.mode === 1) {
      this.getCode();
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  getCode(): void {
    this.preferenceService.getCodePreference(this.id).pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((data) => {
          this.form.get("code")?.setValue(data.code);
        })
      });
  }

  valider() {
    this.preferenceService.copyPreference(this.form.get("code")?.value).pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: ((data) => {
          if (data.id != null) {
            this.preferenceCopied.emit(data);
            this.exitModal();
          } else {
            this.wrongCode=true;
          }
        })
      });
  }

  exitModal() {
    this.modalService.dismissAll();
  }

}
